export default function FullScreenSpinner() {
  return (
    <>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        <div
          className="w-10 h-10 rounded-full border-[3px] border-gray-200 border-t-c-primary"
          style={{ animation: "spin 0.8s linear infinite" }}
        />
      </div>
    </>
  );
}
